export const NEW_POST_CREATED = "NEW_POST_CREATED";
export const EDIT_POST = "EDIT_POST";
export const CANCEL_EDIT_POST = "CANCEL_EDIT_POST";
export const POST_REMOVED = "POST_REMOVED";
export const POST_REACTION = "POST_REACTION";
export const RELOAD_POSTS = "RELOAD_POSTS";
export const FORCE_RELOAD_COMMENTS = "FORCE_RELOAD_COMMENTS";
export const OPEN_POST_DIALOG = "OPEN_POST_DIALOG";
export const CLOSE_POST_DIALOG = "CLOSE_POST_DIALOG";
